let forms = {
	register: {
		icon: 'fa fa-register',
		title: 'Rgister',
		subtitle: 'Register to the System',
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'firstName',
				validation: 'min:3|max:60',
				label: 'First Name',
				placeholder: 'Enter the First Name',
			},
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'lastName',
				validation: 'min:3|max:60',
				label: 'Last Name',
				placeholder: 'Enter the Last Name',
			},
			{
				type: 'text',
				form_type: 'email',
				class: 'col-12',
				model: 'email',
				validation: 'required|min:3|max:150|email',
				label: 'Email',
				placeholder: 'Enter the Email',
			},
			{
				type: 'checkbox',
				class: 'col-12 custom-check',
				model: 'promotions',
				validation: 'required',
				label: 'I want to receive promotional emails',
			},
		],
	},
	passwordSetup: {
		icon: 'fa fa-lock',
		title: 'Password Setup',
		subtitle: '',
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'username',
				validation: 'required|min:3|max:100',
				label: 'Username',
				placeholder: 'Enter the username',
			},
			{
				type: 'text',
				form_type: 'password',
				class: 'col-12',
				model: 'password',
				validation: 'required|min:3|max:60',
				label: 'Password',
				placeholder: 'Enter the password',
			},
			{
				type: 'text',
				form_type: 'password',
				class: 'col-12',
				model: 'confirmPassword',
				validation: 'required|min:3|max:60',
				label: 'Confirm Password',
				placeholder: 'Enter the confirmation password',
			},
			{
				type: 'checkbox',
				class: 'col-12 custom-check',
				model: 'terms',
				validation: 'required',
				label: 'I agree to the <a href="https://agency.nexus.ke/static/media/Nexus%20General%20Terms%20and%20Conditions%2027.7.2020.fa4a0a2ac647c2df199c.pdf" >Terms, Privacy Policy</a> and <a href="#">Fees</a>',
			},
		],
	},
};

module.exports = {
	forms: utils.generateAllFormData(forms),
};
